export default __webpack_public_path__ + "static/media/reliable-icon.e87f0172.svg";